import { render, staticRenderFns } from "./CompanyManagerWrapper.vue?vue&type=template&id=11f50f82&scoped=true&"
import script from "./CompanyManagerWrapper.vue?vue&type=script&lang=ts&"
export * from "./CompanyManagerWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f50f82",
  null
  
)

export default component.exports